import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeRequestsService } from 'src/app/services/change-requests.service';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-requests-history',
  templateUrl: './change-requests-history.component.html',
  styleUrls: ['./change-requests-history.component.scss']
})
export class ChangeRequestsHistoryComponent implements OnInit {

  isLoading = false;
  history: any[] = [];
  newMessage = '';
  mainLogoRoute = "../../assets/img/clients/";
  selectedFiles: File[] = [];
  previews: any[] = [];

  @ViewChild('fileInput') fileInput!: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id_solicitud: number },
    private dialogRef: MatDialogRef<ChangeRequestsHistoryComponent>,
    private changeRequestsService: ChangeRequestsService,
    private main: MainService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getHistory();
  }

  getHistory(): void {
    this.isLoading = true;
    this.changeRequestsService.getChangelog(this.data.id_solicitud).subscribe({
      next: (res: any) => {
        this.history = res.data || [];
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error(err);
        Swal.fire('Error', 'No se pudo cargar el historial.', 'error');
      }
    });
  }

  sendMessage(): void {
    const messageContent = this.newMessage.trim();

    if (!messageContent && this.selectedFiles.length === 0) {
      return; 
    }

    this.isLoading = true;
    this.main.ShowLoading();

    const messagePromise = messageContent
      ? this.changeRequestsService.addMessage({ id_solicitud: this.data.id_solicitud, message: messageContent }).toPromise()
      : Promise.resolve({ message: 'Success' });

    const fileUploadPromises = this.selectedFiles.map(file => {
      const formData = new FormData();
      formData.append('id_solicitud', this.data.id_solicitud.toString());
      formData.append('file', file, file.name); 
      return this.changeRequestsService.uploadImage(formData).toPromise();
    });

    Promise.all([messagePromise, ...fileUploadPromises])
      .then(results => {
        this.main.HideLoading();
        this.isLoading = false;
        const allSuccess = results.every(res => res && res.message === 'Success');
        if (allSuccess) {
          this.newMessage = '';
          this.clearFiles();
          this.getHistory(); // Reload history after all operations
        } else {
          Swal.fire('Error', 'Algunos mensajes o archivos no pudieron ser enviados.', 'error');
        }
      })
      .catch(err => {
        this.main.HideLoading();
        this.isLoading = false;
        console.error(err);
        Swal.fire('Error', 'Ocurrió un error en el servidor al enviar el mensaje o archivos.', 'error');
      });
  }

  // New methods for file selection and preview
  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files) {
      for (let file of files) {
        this.selectedFiles.push(file);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previews.push({
            url: this.sanitizer.bypassSecurityTrustUrl(e.target.result),
            name: file.name,
            type: file.type
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.previews.splice(index, 1);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Clear the input value to allow re-selecting the same file
    }
  }

  clearFiles(): void {
    this.selectedFiles = [];
    this.previews = [];
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  isImage(url: string): boolean {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  getLogoCompany(logImage : string):string{
    return "url(" + this.mainLogoRoute + logImage + ")"
  }
}